$(document).ready(function() {
  InitKlaviyo();
  OpenFirstProductTab();
  ActivateVideoSlider();
  SetupDynamicSizeChart();
});

function OpenFirstProductTab(){
  setTimeout(()=>{
    $('.click_on_ready').trigger("click");
  }, 10);
}

function ActivateVideoSlider(){
  setTimeout(()=>{
    let $firstSlideButton = $('.product-single__gallery .product-single__media-slide').first().find("button");
    if($firstSlideButton.length) { $firstSlideButton.trigger("click"); }
  }, 10);
}

function SetupDynamicSizeChart() {
  SetUpAllCell();
  ActivateDscButtons();
}

function SetUpAllCell() {
  $('.dsc-cell').each(function(){
    SetUpCell($(this), GetDscSizeActive());
  });
}
function SetUpCell($cell, sizeActive){
  let dscCellValue = UseInch() ? $cell.data("inch-size-"+sizeActive) : $cell.data("size-"+sizeActive);
  let unit = UseInch() ? '"' : "cm";
  $cell.find(".dsc-cell-to-complete").text(dscCellValue);
  $cell.find(".unit").text(unit);
}
function ActivateDscButtons() {
  $('.size-chart-trigger, .close-dsc').click(function(e){
    e.preventDefault();
    $('.dynamic-size-chart-pop-up').toggleClass("visually-hidden");
    return false;
  });
  $('.dsc-btn-size').click(function(){
    $('.dsc-btn-size.active').removeClass('active');
    $(this).addClass('active');
    SetUpAllCell();
  });
  $('.dsc-btn-inch-cm').click(function(e) {
    $('.dsc-btn-inch-cm.active').removeClass('active');
    $(this).addClass('active');
    SetUpAllCell();
  });
}

function GetDscSizeActive(){
  return $('.dsc-btn-size.active').data("size");
}
function UseInch(){
  return $('#dsc-btn-inch').hasClass("active") ? true : false;
}

/* Third Party */
function InitKlaviyo() {
  $(document).on('click', ".klaviyo-bis-trigger", function(){
    changeHeadIframe();
  });
  if ($('.product__submit__add').data("available") === false && $('.product__submit__add span').length) {
    $('.custom-size-selector').find(".custom-selector__option.selected").trigger("click");
    setTimeout(function(){
      $('.product__submit__add').prop("disabled", "disabled");
      $('.product__submit__add').css("pointer-events","none");
      $('.product__submit__add').parent().parent().parent().hide();
      $
    }, 100);
  }
}
function changeHeadIframe() {
  if (document.getElementById('klaviyo-bis-iframe') === null || document.getElementById('klaviyo-bis-iframe') === "undefined") {
    setTimeout(changeHeadIframe, 1);
  } else {
    var klaviyoIFrameOutOfStock = document.getElementById('klaviyo-bis-iframe').contentWindow.document.head;
    if (klaviyoIFrameOutOfStock.innerHTML == "" || klaviyoIFrameOutOfStock.innerHTML == null) {
      setTimeout(changeHeadIframe, 1);
    } else {

      /* Set the style */
      var styles = 'h3 {display: block;font-family: Abadi MT STD Bold,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight: 400;margin: 0 0 48px;font-size: 1em;line-height: 1.4;} .klaviyo-bis-close { background: none!important;}';
      styles += '#klaviyo-bis-modal > #container { border-radius: 0; border: 1px solid #000; margin-top: 50%;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;font: 500 14px "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif!important;}';
      styles += 'select {font-weight: 500;border: 1px solid black!important; max-width: 100%; padding: 8px 10px!important; border-radius: 0px!important; height: unset!important; appearance: none; background-image: url(https://cdn.shopify.com/s/files/1/0500/2235/1014/t/16/assets/ico-select.svg?v=18273679090726958689)!important;background-repeat: no-repeat!important;background-position: calc(100% - 7px) center!important;background-size: 16px!important;background-color: transparent!important;padding-right: 28px!important;text-indent: 0.01px;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;}';
      styles += '#email {font-weight: 500;height: unset;border: 1px solid black!important;max-width: 100%;padding: 8px 10px!important;border-radius: 0px!important;}';
      styles += 'p {display: block;font-family: Abadi MT STD Bold,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight: 400;font-size: 1em;line-height: 1.4; padding: 20px 0 20px;}';
      styles += '.close {top: 25px; right: 35px;font-size: 25px!important;font-weight: normal;color: #000!important;text-shadow: 0 0px 0 #fff;font-family: "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;}';
      styles += 'button {font-size: 14px!important;font: 500 14px "Abadi MT STD Bold", "Helvetica Neue", Helvetica, Arial, sans-serif!important;}';
      styles += '.small-print {padding: unset;} ::placeholder {color: #000;}';
      
      var css = document.createElement('style');
      css.type = 'text/css';
      css.appendChild(document.createTextNode(styles));
      klaviyoIFrameOutOfStock.append(css);
    }
  }
}